import apiClient from '@utils/apiClient';
import {
    FarmlandAddReq,
    FarmlandFeatureList,
    FarmlandInfo,
    FarmlandInfoRes,
    FarmlandListReq,
    FarmlandListRes,
    FarmlandUpdateReq,
} from '@/api/growth/farmland/type';
import { ApiOptions, ApiResult } from '@/api/common/type';

export const api = {
    /**
     * 생육농지목록
     * @param param
     */
    farmlandList: async (param: FarmlandListReq): Promise<FarmlandListRes> => {
        const response = await apiClient.post<FarmlandListRes>(
            '/api/v1/growth/farmland/list',
            param,
        );
        return response.data;
    },

    /**
     * 농지 정보등록
     * @param param
     */
    farmlandAdd: async (param: FarmlandAddReq): Promise<ApiResult> => {
        const response = await apiClient.post<ApiResult>(
            '/api/v1/growth/farmland/add',
            param,
        );
        return response.data;
    },

    /**
     * 농지 정보갱신
     * @param param
     */
    farmlandUpdate: async (param: FarmlandUpdateReq): Promise<ApiResult> => {
        const response = await apiClient.put<ApiResult>(
            '/api/v1/growth/farmland/update',
            param,
        );
        return response.data;
    },

    /**
     * 농지 정보삭제
     * @param gfIdx
     */
    farmlandDelete: async (gfIdx: number): Promise<ApiResult> => {
        const response = await apiClient.delete<ApiResult>(
            `/api/v1/growth/farmland/delete/${gfIdx}`,
        );
        return response.data;
    },

    /**
     * 농지정보
     * @param gfIdx
     */
    farmlandInfo: async (gfIdx: number): Promise<FarmlandInfo> => {
        const response = await apiClient.get<FarmlandInfoRes>(
            `/api/v1/growth/farmland/${gfIdx}`,
        );
        return response.data.data;
    },

    /**
     * 농지 지적도목록
     * @param gsIdx
     * @param options
     */
    farmlandFeatureList: async (
        gsIdx: number,
        options: ApiOptions = {},
    ): Promise<FarmlandFeatureList> => {
        const response = await apiClient.get<FarmlandFeatureList>(
            `/api/v1/growth/farmland/features/${gsIdx}`,
            {
                skipLoading: options.skipLoading,
            } as any, // 👈 타입 단언으로 해결
        );
        return response.data;
    },
};
